__turbopack_context__.v({
  "body": "ParagraphContactPerson-module__-5VSKa__body",
  "card": "ParagraphContactPerson-module__-5VSKa__card",
  "contact": "ParagraphContactPerson-module__-5VSKa__contact",
  "contactIcon": "ParagraphContactPerson-module__-5VSKa__contactIcon",
  "contactLabel": "ParagraphContactPerson-module__-5VSKa__contactLabel",
  "contactPhone": "ParagraphContactPerson-module__-5VSKa__contactPhone",
  "cta": "ParagraphContactPerson-module__-5VSKa__cta",
  "hero": "ParagraphContactPerson-module__-5VSKa__hero",
  "heroOverlay": "ParagraphContactPerson-module__-5VSKa__heroOverlay",
  "heroTitle": "ParagraphContactPerson-module__-5VSKa__heroTitle",
  "person": "ParagraphContactPerson-module__-5VSKa__person",
});
